const colors = {
    primary: '#1F8696',
    primaryDark: '#2497A8',
    primaryHover: '#1B757E',
    primaryHoverDark: '#208897',
    primaryActive: '#17666D',
    primaryActiveDark: '#1D7986',
    onPrimary: '#FDFDFD',
    onPrimaryDark: '#FDFDFD',
    primaryContainer: '#F1F8F8',
    primaryContainerDark: '#14435C',
    onPrimaryContainer: '#151411',
    onPrimaryContainerDark: '#FDFDFD',
    secondary: '#FFC120',
    secondaryDark: '#FFC120',
    secondaryHover: '#F5B100',
    secondaryHoverDark: '#F5B100',
    secondaryActive: '#E0A200',
    secondaryActiveDark: '#E0A200',
    onSecondary: '#151411',
    onSecondaryDark: '#151411',
    secondaryContainer: '#FFF4D6',
    secondaryContainerDark: '#705100',
    onSecondaryContainer: '#151411',
    onSecondaryContainerDark: '#FDFDFD',
    accent: '#1F8696',
    accentDark: '#2497A8',
    accentHover: '#1B757E',
    accentHoverDark: '#208897',
    accentHoverAlpha: '#1F86901F', // opacity 12%
    accentHoverAlphaDark: '#2497A81f', // opacity 12%
    accentActive: '#17666D',
    accentActiveDark: '#1D7986',
    accentActiveAlpha: '#1F869029', // opacity 16%
    accentActiveAlphaDark: '#2497A829', // opacity 16%
    onAccent: '#FDFDFD',
    onAccentDark: '#FDFDFD',
    accentContainer: '#DDEFF8',
    accentContainerDark: '#14435C',
    onAccentContainer: '#151411',
    onAccentContainerDark: '#FDFDFD',
    background: '#F6F5F4',
    backgroundDark: '#0B2533',
    onBackground: '#151411',
    onBackgroundDark: '#FDFDFD',
    onBackgroundBorder: '#1514113D', // opacity 24%
    onBackgroundBorderDark: '#FDFDFD3D', // opacity 24%
    onBackgroundSubdued: '#1514117A', // opacity 48%
    onBackgroundSubduedDark: '#FDFDFD7A ', // opacity 48%
    backgroundDisabled: '#1514110F', // opacity 6%
    backgroundDisabledDark: '#FDFDFD0F', // opacity 6%
    onBackgroundHeader: '#151411',
    onBackgroundHeaderDark: '#FDFDFD',
    surface: '#FDFDFD',
    surfaceDark: '#0D2B3B',
    onSurface: '#151411',
    onSurfaceDark: '#FDFDFD',
    onSurfaceBorder: '#1514113D', // opacity 24%
    onSurfaceBorderDark: '#FDFDFD3D', // opacity 24%
    onSurfaceSubdued: '#1514117A', // opacity 48%
    onSurfaceSubduedDark: '#FDFDFD7A', // opacity 48%
    surfaceDisabled: '#1514110F', // opacity 6%
    surfaceDisabledDark: '#FDFDFD0F', // opacity 6%
    onSurfaceHeader: '#151411',
    onSurfaceHeaderDark: '#FDFDFD',
    info: '#2A82C2',
    infoDark: '#2A82C2',
    infoHover: '#2470A8',
    infoHoverDark: '#3691D3',
    infoActive: '#1F608F',
    infoActiveDark: '#4F9FD9',
    onInfo: '#FDFDFD',
    onInfoDark: '#FDFDFD',
    infoContainer: '#D5E8F6',
    infoContainerDark: '#154361',
    onInfoContainer: '#151411',
    onInfoContainerDark: '#FDFDFD',
    success: '#4CAF7B',
    successDark: '#4CAF7B',
    successHover: '#42996B',
    successHoverDark: '#5FBA8A',
    successActive: '#39845C',
    successActiveDark: '#74C39A',
    onSuccess: '#FDFDFD',
    onSuccessDark: '#FDFDFD',
    successContainer: '#D8EEE2',
    successContainerDark: '#20514A',
    onSuccessContainer: '#151411',
    onSuccessContainerDark: '#FDFDFD',
    warning: '#F5C12D',
    warningDark: '#F5C12D',
    warningHover: '#F4B910',
    warningHoverDark: '#F6CA4B',
    warningActive: '#DBA50A',
    warningActiveDark: '#F8D268',
    onWarning: '#151411',
    onWarningDark: '#151411',
    warningContainer: '#FCEEC4',
    warningContainerDark: '#64592B',
    onWarningContainer: '#151411',
    onWarningContainerDark: '#FDFDFD',
    error: '#E94D58',
    errorDark: '#E94D58',
    errorHover: '#E6333F',
    errorHoverDark: '#EC6972',
    errorActive: '#DE1B29',
    errorActiveDark: '#F0848C',
    onError: '#FDFDFD',
    onErrorDark: '#FDFDFD',
    errorContainer: '#FFE5E6',
    errorContainerDark: '#52323F',
    onErrorContainer: '#151411',
    onErrorContainerDark: '#FDFDFD',
    neutral: '#C6C6C6',
    neutralDark: '#525767',
    neutralHover: '#A8A8A8',
    neutralHoverDark: '#656C80',
    neutralActive: '#8D8D8D',
    neutralActiveDark: '#2E2E2E',
    onNeutral: '#000000',
    onNeutralDark: '#000000',
    neutralContainer: '#F4F4F4',
    neutralContainerDark: '#5C5C5C',
    onNeutralContainer: '#000000',
    onNeutralContainerDark: '#F6F9FF',
};
const fonts = {
    header: "'Inter', sans-serif",
    subheader: "'Inter', sans-serif",
    body: "'Inter', sans-serif",
};
const fontStyleSheet = `
  /* latin */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  
  /* latin */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }  

  /* latin */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7W0Q5nw.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  body,html {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
  }
`;
/**
 * Default Casper UI Theme,
 * Based on the design system of Caspeco AB.
 */
export const casperUITheme = {
    colors,
    fonts,
    fontStyleSheet,
};
//# sourceMappingURL=theme-casper-ui.js.map